import script from "./BannerMetaTab.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerMetaTab.vue?vue&type=script&setup=true&lang=js"

import "./BannerMetaTab.vue?vue&type=style&index=0&id=06bb9cda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06bb9cda"]])

export default __exports__